import { Box } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import ScheduledFormsTable from "./ScheduledFormsTable"
import { useEffect } from "react"
import { initializeStudy } from "redux/reducers/studyReducer"
import { createScheduledFormAction, deleteScheduledFormAction, initializeScheduledForms, updateScheduledFormAction } from "redux/reducers/scheduledFormsReducer"

const DisplayScheduledForms = () => {
  const centerId = useSelector(({ center }) => center)?.data?.id
  const scheduledForms = useSelector(({ scheduledForm }) => scheduledForm)
  const selectedCenterStudyId = useSelector(({ center }) => center)?.data?.studyId
  const { data: studyData } = useSelector(({ study }) => study)
  const dispatch = useDispatch()

  useEffect(() => {
    if (centerId && scheduledForms.data?.length === 0) {
      dispatch(initializeScheduledForms(centerId))
    }
  }, [centerId, dispatch])

  useEffect(() => {
    if (selectedCenterStudyId && !studyData) {
      dispatch(initializeStudy(selectedCenterStudyId))
    }
  }, [selectedCenterStudyId, studyData, dispatch])

  const actions = {
    create: createScheduledFormAction,
    update: updateScheduledFormAction,
    remove: deleteScheduledFormAction
  }

  if (!scheduledForms) return null;

  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {centerId && <ScheduledFormsTable entityId={centerId} scheduledForm={scheduledForms} actions={actions} canCreate={true}/>}
    </Box>
  )
}

export default DisplayScheduledForms
